module.exports = __webpack_public_path__ + "yandex_kassa_webmoney.a2dd4de98d5aec10a1e63914cdc9b11e.png";